import React from "react";

export default function SolarTicketLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2 10c0-3.771 0-5.657 1.172-6.828S6.229 2 10 2h4c3.771 0 5.657 0 6.828 1.172S22 6.229 22 10v.5a1.5 1.5 0 0 1 0 3v.5c0 3.771 0 5.657-1.172 6.828S17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.172S2 17.771 2 14v-.5a1.5 1.5 0 0 1 0-3z"></path>
        <path strokeLinecap="round" strokeDasharray="3 3" d="M9 7v10"></path>
      </g>
    </svg>
  );
}
